export enum PlataformaTDSubMenuEnum {
    JORNADAS_DIGITAIS = '1',
    ASSINATURA_ELETRONICA = '2',
    DASHBOARDS = '3',
    CHATBOTS = '4',
    CANAIS_DE_CONTATO = '5',
    FORMULARIOS_DINAMICOS = '6'
}
